import { Price } from '@olxpwa-lib/utils-ad/types';

export const trackPriceParams = (price: Price | null) => {
    if (!price) {
        return {};
    }

    if (price.regularPrice) {
        return {
            ad_price: price.regularPrice.value,
            price_currency: price.regularPrice.currencyCode
        };
    }

    if (price.free) {
        return {
            price_currency: 'free'
        };
    }

    if (price.exchange) {
        return {
            price_currency: 'exchange'
        };
    }

    return {};
};
